import React from 'react';
import { Alert } from '@mui/material';
import CustomButton from '../../../components/Buttons/CustomButton';
import EmailConfirmationContainer from '../../../components/EmailConfirmationContainer';

export default function EmailConfirmationAgain() {
  return (
    <EmailConfirmationContainer>
      <Alert severity="error">Ваша почта уже подтверждена!</Alert>
      <CustomButton href="/">Вернуться на главную</CustomButton>
    </EmailConfirmationContainer>
  );
}
